// Convert to local time
const getTimestamp = (connectionDate: string) =>
  // @ts-expect-error
  Math.floor(new Date(connectionDate) / 1000);

// Todo - convert this to a named export
// eslint-disable-next-line import/no-default-export
export default getTimestamp;
